import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Menu from './components/menu/menu'

import Home from './components/home/home'
import Workshop from './components/workshop/workshop'
import WorkshopPage from './components/workshop/workshop-page'
import CalendarPage from './components/workshop/calendar'
import Blog from './components/blog/blog'
import Schedule from './components/schedule/schedule'
import AboutUs from './components/aboutUs/aboutUs'
import Contact from './components/contact/contact'
import Post from './components/blog/post'
import Login from './components/login'
import Register from './components/register/register'
import Live from './components/live/live'
import ValentinesDay from './components/valentinesDay/valentinesDay'
import BlackFriday from './components/blackFriday'

export default props => (
  <Router>
    <div className="containerRoutes">
      <Menu/>
      <Route path='/' exact component={Home} />
      <Route path='/workshop' exact component={Workshop} />
      <Route path='/blog' exact component={Blog} />
      <Route path='/schedule' exact component={Schedule} />
      <Route path='/home' exact component={Home} />
      <Route path='/aboutUs' exact component={AboutUs} />
      <Route path='/contact' exact component={Contact} />
      <Route path='/post/:id' component={Post} />
      <Route path='/workshop-page/:index/:id' component={WorkshopPage} />
      <Route path='/calendar/:index/:id' component={CalendarPage} />
      <Route path='/login' component={Login} />
      <Route path='/register' component={Register} />
      <Route path='/live' component={Live} />
      <Route path='/valentines-day' component={ValentinesDay} />
      <Route path='/black-friday' exact component={BlackFriday} />
    </div>
  </Router>
)



// WEBPACK FOOTER //
// ./src/routes.js